const LIVRET_KEY = 'livrets';

const livretKeys = {
  all: (schoolyearId: string, schoolId: string) =>
    [schoolyearId, schoolId, LIVRET_KEY] as const,
  print: ['PRINT_LIVRET'],
  livretDetail: (schoolyearId: string, schoolId: string, id: string) =>
    [...livretKeys.all(schoolyearId, schoolId), id] as const,
  livretList: (schoolyearId: string, schoolId: string) =>
    [...livretKeys.all(schoolyearId, schoolId), 'list'] as const,
};

export default livretKeys;
